import React, {Component} from 'react';
import "./privacy.sass"
import FirebaseContext from "../../components/Firebase/context";
import 'antd/dist/antd.css';
import i18next from "../../utils/i18n";


class Privacy extends Component {
    constructor(props) {
        super(props);

        this.state = {loading: false};

    }


    render() {
        const {} = this.state;
        return (
            <div>
                <div className="header_privacy">
                    <div className="logo_privacy"></div>
                    <label className="text_title">{i18next.t('PRIVACY.title')}</label>
                </div>
                <div className="body_privacy">
                    <h2>{i18next.t('PRIVACY.information')}</h2>
                    <label dangerouslySetInnerHTML={{__html: i18next.t('PRIVACY.information_body')}}/>
                    <br/>

                    <h3>{i18next.t('PRIVACY.definition')}</h3>
                    <ul>
                        <li><h4>{i18next.t('PRIVACY.definition_service')}</h4></li>
                        <label>{i18next.t('PRIVACY.definition_service_body')}</label>
                        <br/><br/>
                        <li><h4>{i18next.t('PRIVACY.definition_personal')}</h4></li>
                        <label>{i18next.t('PRIVACY.definition_personal_body')}</label>
                        <br/><br/>
                        <li><h4>{i18next.t('PRIVACY.definition_cookies')}</h4></li>
                        <label>{i18next.t('PRIVACY.definition_cookies_body')}</label>
                        <br/>
                    </ul>
                    <br/>

                    <h3>{i18next.t('PRIVACY.information_use')}</h3>
                    <label>{i18next.t('PRIVACY.information_use_body')}</label>
                    <br/>

                    <h3>{i18next.t('PRIVACY.type_data')}</h3>
                    <h4>{i18next.t('PRIVACY.personal_data')}</h4>
                    <label>{i18next.t('PRIVACY.personal_data_body')}</label>
                    <ul>
                        <br/>
                        <li> <label>{i18next.t('PRIVACY.cookie_active')}</label></li>
                    </ul>
                    <br/>

                    <h4>{i18next.t('PRIVACY.usage_data')}</h4>
                    <label dangerouslySetInnerHTML={{__html: i18next.t('PRIVACY.usage_data_body')}}/>
                    <ul>
                        <li> <label dangerouslySetInnerHTML={{__html: i18next.t('PRIVACY.session_cookie')}}/></li>
                        <li> <label dangerouslySetInnerHTML={{__html: i18next.t('PRIVACY.preference_cookie')}}/></li>
                        <li> <label dangerouslySetInnerHTML={{__html: i18next.t('PRIVACY.safety_cookie')}}/></li>
                    </ul>
                    <br/>

                    <h2>{i18next.t('PRIVACY.use_of_data')}</h2>
                    <label>{i18next.t('PRIVACY.use_of_data_ul')}</label>
                    <ul>
                        <li> <label>{i18next.t('PRIVACY.use_of_data_li_1')}</label></li>
                        <li> <label>{i18next.t('PRIVACY.use_of_data_li_2')}</label></li>
                        <li> <label>{i18next.t('PRIVACY.use_of_data_li_3')}</label></li>
                        <li> <label>{i18next.t('PRIVACY.use_of_data_li_4')}</label></li>
                        <li> <label>{i18next.t('PRIVACY.use_of_data_li_5')}</label></li>
                        <li> <label>{i18next.t('PRIVACY.use_of_data_li_6')}</label></li>
                        <li> <label>{i18next.t('PRIVACY.use_of_data_li_7')}</label></li>
                    </ul>
                    <br/>

                    <h2>{i18next.t('PRIVACY.data_transfer')}</h2>
                    <label dangerouslySetInnerHTML={{__html: i18next.t('PRIVACY.data_transfer_body')}}/>
                    <br/>

                    <h2>{i18next.t('PRIVACY.data_disclosure')}</h2>
                    <h3>{i18next.t('PRIVACY.legal_requirements')}</h3>
                    <label>{i18next.t('PRIVACY.legal_requirements_ul')}</label>
                    <ul>
                        <li> <label>{i18next.t('PRIVACY.legal_requirements_li_1')}</label></li>
                        <li> <label>{i18next.t('PRIVACY.legal_requirements_li_2')}</label></li>
                        <li> <label>{i18next.t('PRIVACY.legal_requirements_li_3')}</label></li>
                        <li> <label>{i18next.t('PRIVACY.legal_requirements_li_4')}</label></li>
                        <li> <label>{i18next.t('PRIVACY.legal_requirements_li_5')}</label></li>
                    </ul>
                    <br/>

                    <h2>{i18next.t('PRIVACY.safety_data')}</h2>
                    <label>{i18next.t('PRIVACY.safety_data_body')}</label>
                    <br/>

                    <h2>{i18next.t('PRIVACY.service_providers')}</h2>
                    <label dangerouslySetInnerHTML={{__html: i18next.t('PRIVACY.service_providers_body')}}/>
                    <br/>

                    <h2>{i18next.t('PRIVACY.link_other_site')}</h2>
                    <label dangerouslySetInnerHTML={{__html: i18next.t('PRIVACY.link_other_site_body')}}/>
                    <br/>

                    <h2>{i18next.t('PRIVACY.privacy_minor')}</h2>
                    <label dangerouslySetInnerHTML={{__html: i18next.t('PRIVACY.privacy_minor_body')}}/>
                    <br/>

                    <h2>{i18next.t('PRIVACY.edit_information_privacy')}</h2>
                    <label dangerouslySetInnerHTML={{__html: i18next.t('PRIVACY.edit_information_privacy_body')}}/>
                    <br/>

                    <h2>{i18next.t('PRIVACY.contact')}</h2>
                    <label>{i18next.t('PRIVACY.contact_ul')}</label>
                    <ul>
                        <li> <label>{i18next.t('PRIVACY.contact_li')}</label></li>
                    </ul>

                </div>
            </div>
        )
    }

}


Privacy.contextType = FirebaseContext;

export default Privacy;